import React, { FormEvent, useEffect, useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import * as reCaptchaKey from '@/shared/constants/reCaptcha'
import './modal-login.scss'
import { siteUrl } from '@/shared/utils/siteUrl'
import userSessionStorage from '@/context/userSessionStorage'
import { StaticImage } from 'gatsby-plugin-image'
import Button from '@/components/atoms/button/button'
import useUserLogged from '@/hooks/useUserLogged'
import { LOCALE_AT } from '@/constants/activity-constants'
const $Iniciar = LOCALE_AT.PARAGUAY ? 'Iniciá' : 'Iniciar'
const $tienes = LOCALE_AT.PARAGUAY ? 'tenés' : 'tienes'
const $Registrate = LOCALE_AT.PARAGUAY ? 'Registrate' : 'Regístrate'
enum REQUEST_STATE {
  idle = 0,
  loading = 1,
  done = 2,
}

function sendLogin(email: string, password: string, captcha: string) {
  return new Promise((resolve, reject) => {
    userSessionStorage.authLogin({
      payload: {
        email,
        password,
        captcha,
      },
      handleSuccess: resolve,
      handleError: reject,
    })
  })
}
function parseIfEmailOrPhone(emailOrPhone: string) {
  const COUNTRY_PHONE_PREFIX = process.env.COUNTRY_PHONE_PREFIX
  // validate if is only numbers
  if (/^\d+$/.test(emailOrPhone)) {
    emailOrPhone = COUNTRY_PHONE_PREFIX + emailOrPhone
  }
  return emailOrPhone
}
export default function ModalLogin({
  forAccess = '',
  onClose,
  captcha = true,
}: {
  forAccess: string
  onClose: (success: boolean) => void
  captcha: boolean
}) {
  const [logged] = useUserLogged()

  const [requestState, setRequestState] = useState(REQUEST_STATE.idle)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const refComponent = useRef(null)
  const recaptchaRef = useRef<any>(null)

  const onHandleSubmit = (event: FormEvent) => {
    event.preventDefault()
    if (requestState !== REQUEST_STATE.idle || !refComponent.current) {
      return
    }
    const htmlComponent = refComponent.current as HTMLElement
    const emailInput = htmlComponent.querySelector(
      "input[name='username']"
    ) as HTMLInputElement
    const passwordIinput = htmlComponent.querySelector(
      "input[name='password']"
    ) as HTMLInputElement

    const email = parseIfEmailOrPhone(emailInput.value)
    const password = passwordIinput.value
    if (email.trim().length === 0 || password.trim().length === 0) {
      // PREVENT EMPTY
      setErrorMessage('Los campos son obligatorios')
      return
    }
    setRequestState(REQUEST_STATE.loading)
    updateCaptcha()
      .then(captcha => {
        return sendLogin(email, password, captcha.value!)
      })
      .then(
        (res: any) => {
          if (res.status === 200) {
            setRequestState(REQUEST_STATE.done)
            onClose(true)
          } else {
            setErrorMessage(res.userMessage)
            setRequestState(REQUEST_STATE.idle)
          }
        },
        (res: any) => {
          setErrorMessage(res.userMessage)
          setRequestState(REQUEST_STATE.idle)
        }
      )
  }

  const updateCaptcha = (): Promise<{
    success: boolean
    value: string | null
    error?: string
  }> => {
    return new Promise(resolve => {
      if (!captcha) {
        resolve({
          success: false,
          value: 'emptytoken',
        })
        return
      }
      if (!recaptchaRef.current) {
        resolve({
          success: false,
          value: null,
        })
        return
      }
      recaptchaRef.current!.execute().then(
        (value: any) => {
          resolve({
            success: true,
            value,
          })
        },
        (error: any) => {
          resolve({
            success: false,
            error,
            value: null,
          })
        }
      )
    })
  }
  useEffect(() => {
    if (logged) {
      onClose(true)
    }
  }, [logged])
  if (logged) {
    return (
      <div className="f-modal-login" ref={refComponent}>
        <div className="wrapper">
          <h3 className="title">
            <b className="accent">Inicia sesión</b> <b> para {forAccess}</b> y
            acceder al resto de los contenidos de BullyingxLoving
          </h3>
          <p style={{ marginTop: '2rem' }}>al parecer Ya estas logeado</p>
        </div>
      </div>
    )
  }
  return (
    <div className="f-modal-login" ref={refComponent}>
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={reCaptchaKey.key}
      />
      <div className="wrapper">
        <div className="hero">
          <StaticImage
            src="../../../assets/images/modal-login/hero.webp"
            alt="hero kid"
            width={110}
            height={122}
            placeholder="blurred"
          />
          d
        </div>
        <h3 className="title">
          <b className="accent">Inicia sesión</b> <b> para {forAccess}</b> y
          acceder al resto de los contenidos de BullyingxLoving
        </h3>
        <form role="form" onSubmit={onHandleSubmit}>
          <label htmlFor="username">
            Correo o celular
            <input
              type="text"
              name="username"
              autoComplete="email"
              disabled={requestState === REQUEST_STATE.loading}
            />
          </label>
          <label htmlFor="password">
            Contraseña
            <input
              type="password"
              name="password"
              disabled={requestState === REQUEST_STATE.loading}
            />
          </label>
          <a
            className="--link --black"
            target="_blank"
            rel="noreferrer"
            href={siteUrl + '/login/recuperar/'}
          >
            ¿Olvidaste tu contraseña?
          </a>

          <Button
            className="f-button"
            type="submit"
            title={'Enviar'}
            loading={requestState === REQUEST_STATE.loading}
            disabled={requestState === REQUEST_STATE.loading}
          >
            {$Iniciar} sesión
          </Button>

          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </form>
        <p className="--link">
          ¿No {$tienes} una cuenta?&nbsp;
          <a
            className="--link"
            rel="noreferrer"
            target="_blank"
            href={siteUrl + '/registro/'}
          >
            {$Registrate} aquí
          </a>
        </p>
      </div>
    </div>
  )
}
